<script setup lang="ts">
import { IconEye, IconEyeClosed } from '@tabler/icons-vue'

const APP_NAME = import.meta.env.VITE_APP_NAME

const loading = ref(false)
const url = new URL(window.location.href)
const token = url.searchParams.get('token')
const email = url.searchParams.get('email')
window.history.pushState({}, document.title, window.location.href.split('?')[0])

const password = ref(null)
const password_confirmation = ref(null)
const errors = ref({})
const success = ref(null)
const { t } = useI18n()
e
async function handleResetPassword(e) {
  e.preventDefault()
  loading.value = true
  try {
    errors.value = {}
    passwordValidation()
    const data = await fetchResetPassword()

    data.message?.email && (errors.value.email = data.message.email)
    data.message?.token && (errors.value.token = data.message.token)

    data.message?.password ? (errors.value.password = data.message.password) : null
    if (Object.keys(errors.value).length === 0) success.value = 'The password has been reset'
  } catch (error) {
    errors.value.password_validation = error.message
    console.error(error.message)
  } finally {
    loading.value = false
  }
}

async function fetchResetPassword() {
  const url = `/api/v1/reset-password`
  const body = {
    password: password.value,
    password_confirmation: password_confirmation.value,
    email: email,
    token: token
  }
  const { data, promise } = useFetch(url, body, 'POST')
  await promise
  return unref(data)
}

const typePassword = ref('password')
function showPassword() {
  if (typePassword.value === 'password') {
    typePassword.value = 'text'
  } else {
    typePassword.value = 'password'
  }
}

function passwordValidation() {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/
  if (password_confirmation.value !== password.value) throw new Error("Password doesn't match")
  if (!regex.test(password.value))
    throw new Error(
      'The password must be 6 characters long and contain one lowercase letter, one uppercase letter, one number.'
    )
}
</script>

<template>
  <div class="bg-light min-vh-100 d-flex flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol :xs="12" :md="12" :lg="6" :xl="4">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit="e => handleResetPassword(e)">
                  <h1>{{ APP_NAME }}</h1>
                  <p class="text-medium-emphasis">
                    {{ t('Enter your new password') }}
                  </p>
                  <CAlert v-if="errors && Object.keys(errors).length !== 0" color="danger">
                    <ul class="mb-0">
                      <li v-if="errors?.email || errors?.token">
                        {{ t('The link used is not valid or it expired') }}
                      </li>
                      <template v-if="errors?.password">
                        <li v-for="(item, index) in errors.password" :key="index">{{ t(item) }}</li>
                      </template>
                      <li v-if="errors?.password_validation">{{ t(errors.password_validation) }}</li>
                    </ul>
                  </CAlert>
                  <CAlert v-if="success" color="success">
                    <ul class="mb-0">
                      <li>{{ t(success) }}</li>
                    </ul>
                  </CAlert>

                  <CInputGroup class="mb-3">
                    <CFormInput :type="typePassword" :placeholder="t('Password')" v-model="password" />
                    <CInputGroupText @click="showPassword">
                      <IconEyeClosed v-if="typePassword === 'password'" />
                      <IconEye v-else />
                    </CInputGroupText>
                  </CInputGroup>

                  <CFormInput
                    type="password"
                    class="mb-3"
                    :placeholder="t('Password Confirmation')"
                    v-model="password_confirmation"
                  />
                  <CRow class="mb-4">
                    <CCol :xs="12" class="text-left">
                      <router-link to="/login">{{ t('Go back') }}</router-link>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol :xs="12" class="d-flex justify-content-end">
                      <CLoadingButton color="primary" type="submit" class="px-4" :loading="loading" :disabled="loading">
                        {{ t('Send') }}
                      </CLoadingButton>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <div class="g-recaptcha" data-sitekey="your_site_key"></div>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<style lang="scss" scoped></style>
